import React, { useRef, useState } from "react";
import { Volume2, VolumeX, RotateCcw } from "lucide-react";

const BTN = "absolute bottom-3 left-3 w-9 h-9 grid place-items-center rounded-full bg-black/45 backdrop-blur-md border border-white/20 text-white hover:bg-black/70 transition-colors";

export const HeroWelcome = () => {
  const ref = useRef(null);
  const boxRef = useRef(null);
  const [ended, setEnded] = useState(false);
  const [muted, setMuted] = useState(true);

  const [progress, setProgress] = useState(0);

  const playWithSound = (v) => {
    v.currentTime = 0;
    v.muted = false;
    v.volume = 1;
    setMuted(false);
    v.play().catch(() => { v.muted = true; setMuted(true); v.play().catch(() => {}); });
  };
  const toggleSound = () => {
    const v = ref.current;
    if (!v) return;
    if (v.muted) return playWithSound(v);
    v.muted = true;
    setMuted(true);
  };
  const replay = () => {
    const v = ref.current;
    setEnded(false);
    boxRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    if (v) playWithSound(v);
  };
  const seek = (e) => {
    const v = ref.current;
    if (!v?.duration) return;
    const r = e.currentTarget.getBoundingClientRect();
    v.currentTime = ((e.clientX - r.left) / r.width) * v.duration;
    v.play().catch(() => {});
  };

  return (
    <div ref={boxRef} className="relative w-full aspect-square scroll-mt-24 rounded-3xl overflow-hidden bg-[#0b0810]" data-testid="hero-welcome">
      <img src="/rawaj-hero.jpg?v=5" alt="رواج الذكية — لأن التفاصيل تصنع التميز"
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${ended ? "opacity-100" : "opacity-0"}`}
        data-testid="hero-image" />
      <video ref={ref} src="/rawaj-welcome.mp4?v=2" poster="/rawaj-hero.jpg?v=5" autoPlay muted playsInline preload="auto"
        onEnded={() => { setEnded(true); setProgress(0); }} onError={() => setEnded(true)}
        onTimeUpdate={(e) => setProgress(e.currentTarget.currentTime / (e.currentTarget.duration || 1))}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${ended ? "opacity-0 pointer-events-none" : "opacity-100"}`}
        data-testid="hero-video" />
      {!ended && (
        <div dir="ltr" onClick={seek} className="absolute bottom-1 left-16 right-4 h-4 flex items-center cursor-pointer group" data-testid="hero-progress">
          <div className="w-full h-1 rounded-full bg-white/20 overflow-hidden group-hover:h-1.5 transition-[height]">
            <div className="h-full bg-primary" style={{ width: `${progress * 100}%` }} />
          </div>
        </div>
      )}
      {!ended ? (
        <button type="button" onClick={toggleSound}
          title={muted ? "تشغيل الصوت" : "كتم الصوت"} aria-label={muted ? "تشغيل الصوت" : "كتم الصوت"}
          className={`${BTN} ${muted ? "ring-2 ring-primary/60 animate-pulse" : ""}`}
          data-testid="hero-sound-btn">
          {muted ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
        </button>
      ) : (
        <button type="button" onClick={replay}
          title="إعادة الفيديو الترحيبي" aria-label="إعادة الفيديو الترحيبي" className={BTN}
          data-testid="hero-replay-btn">
          <RotateCcw className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
